var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":"","no-gutters":""}},[_c('v-col',{staticClass:"pb-3",attrs:{"cols":"12"}},[_c('add-keys',{key:`${_vm.step.id}-variables`,attrs:{"type":"variables","can-edit":_vm.canEdit,"data":_vm.properties.variables},on:{"dataChanged":function($event){return _vm.handleChange('variables', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }